import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-promo-banner-box gfu-promo-banner-box--info" }
const _hoisted_2 = { class: "gfu-promo-banner-box__content" }
const _hoisted_3 = { class: "gfu-hd gfu-hd--h2 gfu-hd--decorative" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_processing_button = _resolveComponent("processing-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString($props.title), 1 /* TEXT */),
      _createElementVNode("p", null, _toDisplayString($props.description), 1 /* TEXT */),
      _createVNode(_component_processing_button, {
        "is-processing": $props.isProcessing,
        theme: $props.buttonTheme,
        class: "_mt-4",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('action')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.buttonLabel), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["is-processing", "theme"])
    ])
  ]))
}